import { WithStyles } from '@material-ui/core';
import styles from './AutoInfoCatalogue.styles';

export interface IAutoInfoCatalogueProps extends WithStyles<typeof styles> {
  dirty?: boolean;
  isValid?: boolean;
  vehicleDetailStates?: {
    openVehicleDetailsDialog: boolean;
    handleVehicleDetailsOnClick?: any;
    setAllowPriceQuantityAutoi?: any;
    setIncludeMoProImages?: any;
    setOpenVehicleDetailsDialog: React.Dispatch<React.SetStateAction<boolean>>;
  };
  allowPriceQuantityDialogAutoi?: boolean;
  changeSelectedTab(selectedTab: string): void;
}

export const transformStates = (data) => {
  return data?.map((item) => ({
    id: item.ReturnValue,
    label: item.Display,
    value: item.ReturnValue,
  }));
};
